// SAT V5 Zone Routes
const satV5Zone = '/sat-v5-zone';

export const routes = {
  base: satV5Zone,

  // Main pages
  dashboard: `${satV5Zone}/dashboard`,
  upload: `${satV5Zone}/upload`,
  schoolStructure: `${satV5Zone}/school-structure`,
  lunchStructure: `${satV5Zone}/lunch-structure`,
  userManagement: `${satV5Zone}/user-management`,
  teacherDetail: `${satV5Zone}/user-management/teacher/:teacherId`,
  pupilDetail: `${satV5Zone}/user-management/pupil/:pupilId`,
  rulesPreferences: `${satV5Zone}/rules-preferences`,
  settings: `${satV5Zone}/settings`,
  analytics: `${satV5Zone}/analytics`,

  // Curriculum Planning
  curriculumPlanning: {
    import: `${satV5Zone}/curriculum-planning/import`,
    plan: `${satV5Zone}/curriculum-planning/plan`,
  },

  // Timetable Management
  timetableManagement: {
    base: `${satV5Zone}/timetable`,
    createTimetable: `${satV5Zone}/timetable/create`,
    views: `${satV5Zone}/timetable/views`,
    subjectOptions: `${satV5Zone}/timetable/subject-options`,
  },

  // System routes
  unauthorized: '/403',
  notFound: '/not-found',
};

export function toRelativePath(absolutePath: string, baseName = '/sat-v5-zone'): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    relative = absolutePath.substring(baseName.length);
  }

  return relative.startsWith('/') ? relative.substring(1) : relative;
}
// Helper to build teacher detail route
export function getTeacherDetailPath(teacherId: string): string {
  return routes.teacherDetail.replace(':teacherId', teacherId);
}

// Helper to build pupil detail route
export function getPupilDetailPath(pupilId: string): string {
  return routes.pupilDetail.replace(':pupilId', pupilId);
}

export default routes;
